// Given the path of the .prproj or .drp file, this function returns the progress JSON file path
// which is written by the AME/DVR launcher feature of Mimir Desktop. This path is checked from
// Kelda in certain cases to check if the encoder script is still actively writing updates.
export const getProgressFilePath = (projectFilePath: string) => `${projectFilePath}-progress.json`;
